module.exports = __webpack_public_path__ + "static/img/12051C_1_R_20201021_LC.e155807.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/12051C_1_R_20201021_LC.png
// module id = asQe
// module chunks = 0